<template>
  <v-container fluid>
    <div v-if="isCliente == 0">
      <section class="content-header">
        <v-toolbar dark dense color="#96298A">
          <v-toolbar-title>RunSheets</v-toolbar-title>
          <v-divider class="mx-4" vertical />
          <v-text-field
            v-model="searcher"
            label="Buscar"
            single-line
            hide-details
            clearable
            max-width="200px"
            @keyup.enter="fillRunsheets()"
            @input="handleChangeSearch()"
          ></v-text-field>
          <v-tooltip bottom color="#96298A">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                ref="getData"
                icon
                @click="fillRunsheets()"
                x-large
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-file-find </v-icon>
              </v-btn>
            </template>
            <span>Buscar</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-divider class="mx-4" vertical />
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="fillCbxShowModal()"
                  x-large
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-database-plus</v-icon>
                </v-btn>
              </template>
              <span>Crear Nuevo</span>
            </v-tooltip>
            <v-divider class="mx-4" vertical />
            <v-tooltip bottom color="#96298A">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="fillRunsheets()"
                  x-large
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-table-refresh</v-icon>
                </v-btn>
              </template>
              <span>Actualizar Tabla</span>
            </v-tooltip>
          </v-toolbar-items>
        </v-toolbar>
      </section>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="runsheets"
            :search="searcher"
            class="elevation-1"
            :options.sync="options"
            :server-items-length="totalData"
          >
            <template v-slot:item.acciones="{ item }">
              <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="primary"
                    @click="showModalPrt(item.id)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-printer</v-icon>
                  </v-btn>
                </template>
                <span>Imprimir</span>
              </v-tooltip>
              <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="info"
                    @click="fillCbxShowModal(true, item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom color="#96298A">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    color="red"
                    @click="deleteItem(item)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar</span>
              </v-tooltip>
            </template>
            <template v-slot:item.cerrado="{ item }">
              <v-icon v-if="item.cerrado" color="green">mdi-check</v-icon>
              <v-icon v-else color="red">mdi-close</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!--FORMULARIO MODAL -->
      <v-dialog
        v-model="dialog"
        :fullscreen="fullScreen"
        transition="dialog-bottom-transition"
        persistent
        width="800"
      >
        <v-card elevation="24" outlined>
          <v-toolbar dark dense color="#96298A">
            <v-toolbar-title>Runsheet - {{ camposBD.hoja }}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-divider vertical />
              <v-btn v-if="!fullScreen" icon dark @click="fullScreen = true">
                <v-icon>mdi-window-maximize</v-icon>
              </v-btn>
              <v-btn v-if="fullScreen" icon dark @click="fullScreen = false">
                <v-icon>mdi-window-minimize</v-icon>
              </v-btn>
              <v-divider vertical />
              <v-btn icon dark @click="closeAndResetCbx()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-divider vertical />
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="12" sm="12" md="6">
                  <v-combobox
                    v-model="courier"
                    :items="couriers"
                    item-text="nombre"
                    item-value="id"
                    label="Courier"
                    :rules="[reglas.requeridoCbx]"
                    required
                    append-icon="topic"
                    return-object
                  ></v-combobox>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                      <v-text-field
                        v-model="camposBD.fecha"
                        label="Fecha"
                        type="date"
                        :rules="[reglas.requeridoTxt]"
                        required
                      ></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="3">
                      <v-text-field
                        v-model="camposBD.hora"
                        label="Hora"
                        type="time"

                        :rules="[reglas.requeridoTxt]"
                        required
                      ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-card height="100%" elevation="24" outlined shaped>
                    <v-card-title>Seleccionar guias a Agregar</v-card-title>
                    <v-card-text>
                      <!--v-combobox
                        v-model="guiaAdd"
                        :items="guiasAdd"
                        item-text="guia_interna"
                        item-value="id"
                        label="Guia"
                        append-icon="edit"
                        return-object
                      ></v-combobox-->
                      <!--v-autocomplete
                        v-model="guiaAdd"
                        :items="guiasAdd"
                        :search-input.sync="search"
                        item-value="id"
                        item-text="guia_interna"
                        clearable
                        return-object
                        cache-items
                        hide-no-data
                        hide-details
                        label="Guía"
                      >
                      </v-autocomplete-->
                      <v-textarea
                      v-model="searchGuiaAdd"
                      ref="searchGuiaAdd"
                      clearable
                      label="Escanee o ingrese Guía (presione Enter)"
                      append-icon="mdi-earth"
                      @keyup.enter="addGuiaRunSheet()"
                      ></v-textarea>
                    </v-card-text>
                    <!--v-card-actions>
                      <v-spacer></v-spacer
                      ><v-btn
                        dark
                        small
                        color="light-blue darken-4"
                        @click="addGuiaRunSheet()"
                        outlined
                        >Agregar <v-icon>mdi-arrow-right-box</v-icon></v-btn
                      >
                    </v-card-actions-->
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="8">
                  <v-card height="100%" elevation="24" outlined shaped>
                    <v-card-title>Guias RunSheet</v-card-title>
                    <v-card-text>
                      <v-data-table
                        v-model="selectedGuiasRS"
                        :headers="headersGR"
                        :items="guiasRunseet"
                        :single-select="false"
                        show-select
                        item-key="guia_interna"
                        class="elevation-1"
                      >
                        <template v-slot:item.acciones="{ item }">
                          <v-menu offset-y>
                            <template #activator="{ on: onMenu }">
                              <v-tooltip bottom color="#96298A">
                                <template #activator="{ on: onTooltip }">
                                  <v-btn
                                    v-on="{ ...onMenu, ...onTooltip }"
                                    icon
                                    color="teal"
                                  >
                                    <v-icon>mdi-file-image</v-icon>
                                  </v-btn>
                                </template>
                                <span>Imagenes</span>
                              </v-tooltip>
                            </template>
                            <v-list>
                              <v-list-item
                                dense
                                v-for="(file,index) in item.files"
                                :key="index"
                              >
                                <v-list-item-content>
                                  <v-list-item-title
                                    >{{file}}</v-list-item-title
                                  >
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-tooltip bottom color="#96298A">
                                  <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon color="blue" @click="descargarImagenPod(file)" v-bind="attrs"
                                  v-on="on">
                                  <v-icon>mdi-eye-check</v-icon>
                                  </v-btn>
                                  </template>
                                    <span>Ver</span>
                                  </v-tooltip>
                                  <v-tooltip bottom color="#96298A">
                                  <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon color="blue" @click="descargarImagenPod(file, true)" v-bind="attrs"
                                  v-on="on">
                                  <v-icon>mdi-cloud-download</v-icon>
                                  </v-btn>
                                  </template>
                                    <span>Descargar</span>
                                  </v-tooltip>
                                  <v-tooltip bottom color="#96298A">
                                  <template v-slot:activator="{ on, attrs }">
                                  <v-btn icon color="red" @click="eliminarImagenPod(file)" v-bind="attrs"
                                  v-on="on">
                                  <v-icon>mdi-delete</v-icon>
                                  </v-btn>
                                  </template>
                                    <span>Eliminar</span>
                                  </v-tooltip>
                                </v-list-item-action>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                          <v-tooltip bottom color="#96298A">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                color="red"
                                @click="deletegrs(item)"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Eliminar</span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer
                      ><v-btn @click="showModalPod()" color="info" outlined v-if="modalEditando"
                        >Actualizar POD (Seleccionadas)</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12" class="d-flex justify-end"
                  ><v-checkbox
                    color="indigo darken-4"
                    label="Cerrado"
                    v-model="camposBD.cerrado"
                    v-if="modalEditando"
                  ></v-checkbox
                ></v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error darken-1" @click="closeAndResetCbx()" outlined>
              Cancelar
              <v-icon dark>mdi-close</v-icon>
            </v-btn>
            <v-btn color="primary darken-1" @click="saveItem()" outlined>
              Guardar
              <v-icon dark>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--FORMULARIO MODAL -->
      <!--MODAL POD-->
      <v-dialog
        v-model="dialogpod"
        width="800"
        height="800"
        transition="dialog-bottom-transition"
        persistent
      >
        <v-card>
          <v-toolbar dark dense color="#96298A">
            <v-toolbar-title
              >Agregar Prueba de Entrega a Guías Seleccionadas</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click="cerrarModalPod()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="pod.fecha"
                          label="Fecha"
                          type="date"
                        ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="pod.hora"
                          label="Hora"
                          type="time"
                        ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="pod.observaciones"
                      label="Persona que recibe"
                      append-icon="edit"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!--v-row>
              <v-col cols="12" sm="12" md="12">
                <v-combobox
                  v-model="estatus"
                  label="Estatus"
                  required
                  :rules="[reglas.requeridoTxt]"
                  :items="lstEstatus"
                  item-value="id"
                  item-text="descripcion"
                />
              </v-col>
            </v-row-->
            <v-row>
              <v-col class="d-flex child-flex" cols="10" sm="8" md="8">
                <v-text-field
                  label="Archivo(s)"
                  readonly
                  v-model="imgUrl"
                  hint="Esta(s) imagen(es) se cargara(n) a las POD de cada una de las guías seleccionadas"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="2" sm="4" md="4">
                <v-btn color="primary" @click="pickFoto()" rounded outlined
                  >Seleccionar...<v-icon>mdi-folder-open</v-icon></v-btn
                >
                <input
                  type="file"
                  ref="filefoto"
                  style="display: none"
                  multiple
                  @change="onFotoPicked"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer
            ><v-btn color="info" @click="actualizarPod()" outlined>
              Guardar <v-icon>mdi-content-save-settings</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--MODAL POD-->
      <!--MODAL PRT-->
      <v-dialog
        v-model="dialogprt"
        width="900"
        transition="dialog-bottom-transition"
        persistent
        scrollable
      >
        <v-card>
            <v-toolbar dark dense color="#96298A">
              <v-toolbar-title>Imprimir Runsheet</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="cerrarModalPrt()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          <v-card-text>
            <printrs :id="idRs" v-if="prrs" />
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--MODAL PRT -->
      <v-overlay :value="overlay">
        <waiting />
      </v-overlay>
    </div>
    <div v-else>
      <h1>Usted no tiene permisos para ver esta sección</h1>
    </div>
  </v-container>
</template>
<script>
import apicon from "../plugins/apicon";
import Printrs from "../components/Printrunsheet.vue";
import Waiting from "../components/Waiting.vue";
import utils from "../utils/utils";
import moment from 'moment-timezone';
export default {
  components: {
    Printrs,
    Waiting,
  },
  created: function () {},
  data() {
    return {
      search: null,
      overlay: false,
      fullScreen: true,
      searcher: "",
      options: {},
      totalData: 0,
      dialog: false,
      valid: true,
      modalEditando: false,
      dialogpod: false,
      dialogprt: false,
      runsheets: [],
      couriers: [],
      courier: null,
      guiasAdd: [],
      guiaAdd: null,
      searchGuiaAdd: null,
      guiasRunseet: [],
      selectedGuiasRS: [],
      pod: {
        fecha: null,
        hora: null,
        observaciones: null,
      },
      headers: [
        { text: "Hoja", value: "hoja" },
        { text: "Courier", value: "courier.nombre" },
        { text: "Fecha", value: "fecha" },
        { text: "Hora", value: "hora" },
        { text: "Cerrado", value: "cerrado" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      headersGR: [
        { text: "Guia", value: "guia_interna" },
        { text: "Fecha Entrega", value: "podfecha" },
        { text: "Hora Entrega", value: "podhora" },
        { text: "Persona que recibe", value: "podnombre" },
        { text: "Estatus", value: "estatus" },
        { text: "Files", value: "files" },
        { text: "Acciones", value: "acciones", align: "end", sortable: false },
      ],
      /*Variables*/
      camposBD: {
        id: 0,
        id_courier: null,
        fecha: null,
        hora: null,
        hoja: null,
        cerrado: false,
        guiasrunsheet: [],
      },
      /*Variables*/
      idRs: 0,
      prrs: false,
      isCliente: 1,
      imgUrl: [],
      files: [],
      lstEstatus: [],
      estatus: null,
    };
  },
  watch: {
    courier: function (item) {
      if (item) {
        this.camposBD.id_courier = item.id;
      }
    },
    options: {
      handler() {
        this.fillRunsheets();
      },
      deep: true,
    },
    search(val) {
      val && val !== this.guiaAdd && this.fillGuiasAdd(val);
    },
  },
  methods: {
    pickFoto: function () {
      this.$refs.filefoto.click();
    },
    onFotoPicked: function (e) {
      const files = e.target.files;
      this.files = files;
      for (var i = 0; i <= files.length - 1; i++) {
        if (files[i] !== undefined) {
          if (files[i].name.lastIndexOf(".") <= 0) {
            return;
          }
          //this.imageFile = files[0];
          this.imgUrl.push(files[i].name);
        }
      }
    },
    uploadImages: async function (id_guia) {
      for (var i = 0; i <= this.files.length - 1; i++) {
        let fd = new FormData();
        fd.append("image", this.files[i]);
        await apicon
          .saveDataApi(
            apicon.getApiBaseUrl() + "guias/uploadpod/" + id_guia,
            fd
          )
          .then((result) => {
            console.log(result);
          });
      }
    },
    cerrarModalPod: function () {
      this.pod.fecha = null;
      this.pod.hora = null;
      this.pod.observaciones = null;
      this.dialogpod = false;
    },
    cerrarModalPrt: function () {
      this.idRs = 0;
      this.prrs = false;
      this.dialogprt = false;
    },
    showModalPod: function () {
      this.setFechaActual();
      this.dialogpod = true;
    },
    showModalPrt: function (id) {
      this.idRs = id;
      this.prrs = true;
      this.dialogprt = true;
    },
    actualizarPod: function () {
      var datos = {
        guias: JSON.stringify(this.selectedGuiasRS),
        pod: this.pod,
        id_estatus: this.estatus != null ? this.estatus.id : null
      };
      apicon
        .saveDataApi(apicon.getApiBaseUrl() + "updatepod", datos)
        .then(async () => {
          //Subir las imagenes
          for (var i = 0; i <= this.selectedGuiasRS.length - 1; i++) {
            await this.uploadImages(this.selectedGuiasRS[i].id_guia);
          }
          this.selectedGuiasRS = [];
          this.fillGuiasRunsheet();
          this.cerrarModalPod();
        });
    },
    //Obtener los datos para rellenar la tabla del index
    fillRunsheets: function () {
      const { page, itemsPerPage } = this.options;
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() +
            "runsheet?page=" +
            page +
            "&per_page=" +
            itemsPerPage +
            (this.searcher != null ? "&search=" + this.searcher : "")
        )
        .then((result) => {
          this.runsheets = result.data;
          this.totalData = result.total;
        });
    },
    fillCouriers: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "courier")
        .then((result) => {
          this.couriers = result;
        });
    },
    fillGuiasAdd: async function (v) {
      /*await apicon.getDataApi(apicon.getApiBaseUrl() + 'guiasrs').then((result) => {
        this.guiasAdd = result;
      });*/
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guiasrs?search=" + this.search)
        .then((result) => {
          this.guiasAdd = result;
        });
    },
    //Agregar guia a Runsheet
    addGuiaRunSheet: async function () {
      //if (ga === -1) {
        let guias = this.searchGuiaAdd.split(',');
            if(guias.length == 1){//es porque no estan separadas por coma y probablemente por espacio
              guias = this.searchGuiaAdd.split('\n').filter(item => item.trim() !== '');
            }

            guias.forEach(async guia => {
                if(guia != null && guia != ''){
                    //Agregar
                    let flag = true //await this.verificarGuiaExiste(guia);
                    if (flag) {
                      var guiaA = {
                          id: 0,
                          id_runsheet: this.camposBD.id,
                          id_guia: null,
                          guia_interna: guia,
                          podfecha: null,
                          podhora: null,
                          observaciones: null,
                        };
                        //Verificar si ya fue agregada para no agregar
                        var ga = this.guiasRunseet.findIndex(
                          (g) => g.guia_interna === guiaA.guia_interna
                        );
                        if(ga !== -1){
                          console.log("Guía agregada con anteriorioridad");
                          return;
                        }
                        this.guiasRunseet.push(guiaA);
                    } else {
                      console.log("Esta guía No Existe");
                    }
                }
            });
            //await this.guardarGuiasRS();
            this.$refs.searchGuiaAdd.focus();
            this.searchGuiaAdd = null;
    },
    /*guardarGuiasRS: async function(){
        apicon
          .saveDataApi(apicon.getApiBaseUrl() + "guiasrunsheetbulk", {guias : this.guiasRunseet})
          .then((result) => {
            if (result.status) {
              this.fillGuiasRunsheet();
            } else {
              console.log(result.message);
            }
          });
    },
    verificarGuiaExiste: async function (guia) {
      let flag = false;
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "verificarguiarsexiste/" + guia)
        .then((result) => {
          if (result.status) {
            flag = true;
            this.guiaAdd = result.guia;
          }
        });
      return flag;
    },*/
    deletegrs: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
            if (self.modalEditando) {
            apicon
              .deleteDataApi(apicon.getApiBaseUrl() + "guiasrunsheet/" + item.id)
              .then(() => {
                self.fillGuiasRunsheet();
              });
          } else {
            self.guiasRunseet.splice(
              self.guiasRunseet.findIndex(
                (g) => g.guia_interna === item.guia_interna
              ),
              1
            );
          }
        }
      });
    },
    fillGuiasRunsheet: function () {
      apicon
        .getDataApi(
          apicon.getApiBaseUrl() + "guiasrunsheet/" + this.camposBD.id
        )
        .then((result) => {
          this.guiasRunseet = result;
        });
    },
    //Guardar o Actualizar
    saveItem: function () {
      if (this.$refs.form.validate()) {
        this.camposBD.guiasrunsheet = JSON.stringify(this.guiasRunseet);
        //Actualizar
        if (this.modalEditando) {
          var url = apicon.getApiBaseUrl() + "runsheet/" + this.camposBD.id;
          apicon.updateDataApi(url, this.camposBD).then((result) => {
            this.fillRunsheets();
            this.closeAndResetCbx();
            this.$swal(result.message);
          });
        } else {
          this.camposBD.guiasrunsheet = JSON.stringify(this.guiasRunseet);
          //Guardar
          apicon
            .saveDataApi(apicon.getApiBaseUrl() + "runsheet", this.camposBD)
            .then((result) => {
              this.fillRunsheets();
              this.closeAndResetCbx();
              this.$swal(result.message);
            });
        }
      }
    },
    //Eliminar
    deleteItem: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          var url = apicon.getApiBaseUrl() + "runsheet/" + item.id;
          apicon.deleteDataApi(url).then((result) => {
            self.fillRunsheets();
            this.$swal(result.message);
          });
        }
      });
    },
    fillCbxShowModal: async function (editando = false, item = []) {
      this.modalEditando = editando;
      await this.fillCouriers();
      await this.getLstEstatus();
      if (editando) {
        await Object.keys(this.camposBD).forEach((key) => {
          this.camposBD[key] = item[key];
        });
        this.courier = item.courier;
        this.fillGuiasRunsheet();
      } else {
        this.limpiarCampos();
      }
      this.dialog = true;
    },
    limpiarCampos: function () {
      Object.keys(this.camposBD).forEach((key) => {
        this.camposBD[key] = null;
      });
      this.camposBD.cerrado = false; //Este campo no puede ser null
      this.courier = null;
      this.guiasRunseet = [];
      this.guiaAdd = null;
      this.guiasAdd = [];
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    closeAndResetCbx: function () {
      this.limpiarCampos();
      this.dialog = false;
    },
    handleChangeSearch: function () {
      if (this.searcher == null || this.searcher == "") {
        this.fillRunsheets();
      }
    },
    descargarImagenPod: function (imagen,descargar = false) {
      let ext = imagen.substring(imagen.indexOf("."));
      let imgName = imagen.replace(ext,'');
      let tipo = null;
      switch(ext){
          case '.pdf':
            tipo = 'application/pdf';
            break;
          case '.gif':
            tipo = 'image/gif';
            break;
          case '.jpg':
            tipo = 'image/jpg'
            break;
          case '.png':
            tipo = 'image/png';
            break;
          case '.webp':
            tipo = 'image/png';
            break;
          default :
            null
            break;

      }
      //Verificar si selecciono vista previa y no se puede
      if(!descargar == true && tipo == null){
        this.$swal("El documento seleccionado no admite la vista previa");
        return;
      }
      apicon
        .downloadDataApi(apicon.getApiBaseUrl() + "downimagenpod", {
          imagen: imagen,
        })
        .then((result) => {
          utils.forceFileDownload(
            result,
            ext,
            !descargar,
            imgName,
            tipo
          );
        });
    },
    eliminarImagenPod(imagen){
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon.saveDataApi(apicon.getApiBaseUrl() + 'delimagenpod',{imagen : imagen})
            .then((result) => {
                self.fillGuiasRunsheet();
                this.$swal(result.message);
            });
        }
      });
    },
    getLstEstatus: function () {
      apicon
        .getDataApi(apicon.getApiBaseUrl() + 'estatusall')
        .then((result) => {
          this.lstEstatus = result
        })
    },
    setFechaActual: function(){
      let fechaActual = moment(new Date()).tz(this.timeZone);
      this.pod.fecha = moment(fechaActual).format("YYYY-MM-DD");
      this.pod.hora = moment(fechaActual).format("HH:mm");
    }
  },
  mounted() {
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
  },
};
</script>
